module.exports = __webpack_public_path__ + "assets/img/icon_login_isScan2.50d1f4e6.png";